import { useEffect } from 'react'
import { Toast } from '../ui'
import { useAppStore } from '../../stores/useAppStore'

const NotificationContainer = () => {
  const { notifications, removeNotification } = useAppStore()

  useEffect(() => {
    notifications.forEach((notification) => {
      if (notification.duration !== 0) {
        const timer = setTimeout(() => {
          removeNotification(notification.id)
        }, notification.duration || 5000)

        return () => clearTimeout(timer)
      }
    })
  }, [notifications, removeNotification])

  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50"
    >
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        {notifications.map((notification) => (
          <Toast
            key={notification.id}
            id={notification.id}
            title={notification.title}
            message={notification.message}
            type={notification.type}
            isVisible={true}
            onClose={removeNotification}
            duration={notification.duration}
          />
        ))}
      </div>
    </div>
  )
}

export default NotificationContainer
